import { render, staticRenderFns } from "./CustomerInvoiceView.vue?vue&type=template&id=5010dad8&scoped=true&"
import script from "./CustomerInvoiceView.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoiceView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInvoiceView.vue?vue&type=style&index=0&id=5010dad8&prod&lang=scss&scoped=true&"
import style1 from "./CustomerInvoiceView.vue?vue&type=style&index=1&id=5010dad8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5010dad8",
  null
  
)

export default component.exports